var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFromTemplate)?_c('div',{staticClass:"indicator-container",class:{'ml-1 my-1': _vm.useDefaultMargins},attrs:{"title":_vm.$t('tvtemplatesSpotFromTemplate')}},[_c('v-icon',{staticClass:"msr--text"},[_vm._v("\n      web\n    ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/FromTemplateIndicator.vue?vue&type=template&id=be90092a&scoped=true
// module id = 1517
// module chunks = 5